export function messageFromError(error: unknown): string {
  if (typeof error === "string") {
    return error
  } else if (error instanceof Error && error.message !== "[object Object]") {
    return error.message
  } else if (
    typeof error === "object" &&
    error !== null &&
    "message" in error &&
    typeof error.message === "string" &&
    error.message !== "[object Object]"
  ) {
    return error.message
  } else {
    try {
      return JSON.stringify(error)
    } catch {
      return String(error)
    }
  }
}
